import { useConditionFieldFieldPath } from '../fieldPaths';
import { useQueryErrorStateContext } from '../../../contexts/queryErrorState';

export const useHasConditionFieldWarning = () => {
  const fieldPath = useConditionFieldFieldPath();
  const { getHasWarningFromFieldPath } = useQueryErrorStateContext();
  const warningFromFieldPath = getHasWarningFromFieldPath(fieldPath);

  return warningFromFieldPath;
};
